import {lazy, Suspense, useEffect, useState} from "react";
import {BrowserRouter, Route, Routes, useLocation} from "react-router-dom";

import Header from "./components/Header.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";

import {API_BASE_URL} from "./config.js";

import Home from "./pages/Home.jsx";
const Keys = lazy(() => import("./pages/Keys.jsx"));
const Jobs = lazy(() => import("./pages/Jobs.jsx"));
const Login = lazy(() => import("./pages/Login.jsx"));
const Logout = lazy(() => import("./pages/Logout.jsx"));
const NotFound = lazy(() => import("./pages/NotFound.jsx"));
const Docs = lazy(() => import("./pages/Docs.jsx"));

function AppInner() {
    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    const refreshSession = async() => {
        try {
            const res = await fetch(`${API_BASE_URL}/auth/session`, {
                method: "GET",
                credentials: "include",
            });

            if(!res.ok) {
                setSession(null);
                return;
            };

            const data = await res.json();
            setSession(data.loggedIn ? data : null);
        }catch (e) {
            setSession(null);
        }finally {
            setLoading(false);
        };
    };

    useEffect(() => {
        refreshSession();
    }, [location.pathname]);

    useEffect(() => {
        if(location.hash) return;
        window.scrollTo({top: 0, behavior: "instant"});
    }, [location.pathname, location.hash]);

    useEffect(() => {
        if(!session) return;

        const interval = setInterval(() => {
            refreshSession();
        }, 5 * 60 * 1000);

        return () => clearInterval(interval);
    }, [session]);

    const loadingView = (
        <div className="main">
            <p className="missing">Loading...</p>
        </div>
    );

    return (
        <div className="container">
            <Header session={session}/>
            <main className="content">
                {loading ? (
                    loadingView
                ) : (
                    <Suspense fallback={loadingView}>
                        <Routes>
                            <Route path="/" element={<Home/>}/>
                            <Route path="/docs" element={<Docs/>}/>
                            <Route path="/login" element={<Login/>}/>
                            <Route path="/logout" element={<Logout/>}/>
                            <Route element={<ProtectedRoute session={session}/>}>
                                <Route path="/keys" element={<Keys/>}/>
                                <Route path="/jobs" element={<Jobs/>}/>
                            </Route>
                            <Route path="*" element={<NotFound/>}/>
                        </Routes>
                    </Suspense>
                )}
            </main>
            <footer className="footer">
                QCloud by DTU Physics
            </footer>
        </div>
    );
};

export default function App() {
    return (
        <BrowserRouter>
            <AppInner/>
        </BrowserRouter>
    );
};
